import { Component, OnInit, Input } from '@angular/core'

@Component({
    selector: 'app-modal-fundamento',
    templateUrl: './modal-fundamento.component.html',
    styleUrls: ['./modal-fundamento.component.scss']
})

export class ModalFundamentoComponent implements OnInit {

    @Input('idModal') idModal;
    @Input() fundamento;

    constructor() {

    }

    ngOnInit() {

    }

}